import React, { ReactElement } from 'react';
import cIf from 'classnames';
import { Warning, WarningKeyEnum, WarningKindEnum } from '../../../logic/models/ticketselectionwarning';
import { getWarningMessage } from '../../../logic';
import './ticket-selection-warning-list.scss';
import { useIFrameResize } from '../../../logic/hooks/utils';
import { useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';


type TicketSelectionWarningListProps = {
    warnings: Warning[];
    alertMode?: boolean;
}

export function TicketSelectionWarningList({warnings, alertMode = false}: TicketSelectionWarningListProps): ReactElement {
    useIFrameResize();
    const isAPackageSale = useAddPackageToCartStoreExt(s => s.isAPackageSale);
    
    // Remove the HAVE_EXPIRED_TICKETS warnings and HAVE_ALREADY_TICKETS_IN_CART warnings because displaying with toasts messages
    const filteredWarnings = warnings.filter(warning => warning.key !== WarningKeyEnum.HAVE_EXPIRED_TICKETS && warning.key !== WarningKeyEnum.HAVE_ALREADY_TICKETS_IN_CART);

    const priceInformationContent = filteredWarnings.map((w, i) => {
        const warningContent = <div key={"warning_" + i} className={cIf({"kind-error": w.kind === WarningKindEnum.Error})}>
            {w.kind === WarningKindEnum.Error && <i className="fas fa-exclamation-circle"></i>}
            <i>
                {getWarningMessage(w, isAPackageSale())}
            </i>
        </div>;
        if(alertMode) 
            return <div key={"alert_" + i} className="alert alert-danger">{warningContent}</div>;
        else
            return warningContent;
    });

    return <div className="ticket-selection-warning-list">
        {priceInformationContent}
    </div>;
}